import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Signup from "@/pages/Signup";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import OnboardingBrand from "@/pages/OnboardingBrand";
import OnboardingFirstLog from "@/pages/OnboardingFirstLog";
import Dashboard from "@/pages/Dashboard";
import WeeklyLog from "@/pages/WeeklyLog";
import History from "@/pages/History";
import Insights from "@/pages/Insights";
import Upgrade from "@/pages/Upgrade";
import PaymentSuccess from "@/pages/PaymentSuccess";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google Auth callback (URL hash contains session_id)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="/onboarding/brand" element={<ProtectedRoute><OnboardingBrand /></ProtectedRoute>} />
      <Route path="/onboarding/first-log" element={<ProtectedRoute><OnboardingFirstLog /></ProtectedRoute>} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/log" element={<ProtectedRoute><WeeklyLog /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
      <Route path="/insights" element={<ProtectedRoute><Insights /></ProtectedRoute>} />

      {/* Upgrade and payment must be accessible even if trial expired */}
      <Route path="/upgrade" element={<ProtectedRoute allowExpired><Upgrade /></ProtectedRoute>} />
      <Route path="/payment-success" element={<ProtectedRoute allowExpired><PaymentSuccess /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
